export default "__VITE_ASSET__d11dfe66__"